import React from 'react'

const DangerZone = ({ onDeleteAccount }) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
      <div className="mb-4 sm:mb-0">
        <h3 className="text-lg font-semibold text-red-400 mb-2">Delete Account</h3>
        <p className="text-red-300 text-sm">
          Permanently delete your account and all associated data. This action cannot be undone.
        </p>
      </div>
      <button
        onClick={onDeleteAccount}
        className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors duration-300 whitespace-nowrap"
      >
        Delete Account
      </button>
    </div>
  )
}

export default DangerZone